import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import StudentNav from "../Navbars/StudentNav";
import Header from "../Header";
import Footer from "../Footer";
import { toast } from "react-toastify";
import "./StudentReward.css";
import { Bell, Coins, Gift, Star } from "lucide-react";
import { RiCopperCoinFill } from "react-icons/ri";

import axiosInstance from "./axiosInstance";
import axios from "axios";

function StduentReward() {
  const [activeTab, setActiveTab] = useState("redeem");
  const [loading, setLoading] = useState(false);
  const [rewards, setRewards] = useState([]);
  const [earnedPoints, setEarnedPoints] = useState(0);
  const [Rewards_Earned, setRewardsEarned] = useState({
    earned: 0,
    redeemed: 0,
  });
  const [redeemHistory, setRedeemHistory] = useState([]);
  const [selectedTerms, setSelectedTerms] = useState(null);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const navigate = useNavigate();
  const { isStudent, setUserRole, setUserInfo, userInfo } =
    useContext(UserContext);
  const [userType, setUserType] = useState("");

  // Fetch rewards earned for the student
  const fetchRewardsEarned = async () => {
    try {
      const response = await axios.get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentRewards`,
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      console.log("API Response:", response.data);
      if (response.status === 200) {
        setRewardsEarned({
          earned: response.data.Rewards_Earned,
          redeemed: response.data.Rewards_Redeemed,
        });
      }
    } catch (error) {
      console.error("Error fetching rewards earned:", error);
      toast.error("Failed to load rewards data", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  useEffect(() => {
    fetchRewardsEarned();
  }, []);

  // Fetch rewards from backend
  const fetchRewards = () => {
    console.log("🔍 fetchRewards function called");
    console.log(
      "🔍 API URL:",
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getRewardsForStudents`
    );
    setLoading(true);
    axios
      .get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getRewardsForStudents`, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        console.log("✅ API call successful");

        setEarnedPoints(parseInt(response?.data?.rewards_earned));
        setRewards(response.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("❌ Error fetching redeem Data:", error);
        console.error("❌ Error response:", error.response);
        console.error("❌ Error message:", error.message);
        toast.error("Failed to load redeem Data", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoading(false);
      });
  };
  useEffect(() => {
    console.log("🔄 useEffect triggered - calling fetchRewards");
    fetchRewards();
  }, []);

  // Fetch redeem history from backend
  useEffect(() => {
    const fetchRedeemHistory = () => {
      setLoading(true);
      // axiosInstance.get("/StudentRedeemHistory")
      axios
        .get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/StudentRedeemHistory`, {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          // Format the data to match the frontend structure
          const formattedHistory = response.data.map((item) => ({
            id: item.gift_id,
            gift: item.giftname,
            date: new Date(item.redeemtime).toLocaleDateString(),
            status: item.status,
            giftpicture: item.giftpicture, // Add gift picture to the history item
            student_name: item.student_name,
          }));
          setRedeemHistory(formattedHistory);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching redeem history:", error);
          toast.error("Failed to load redeem history", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoading(false);
        });
    };

    if (activeTab === "history") {
      console.log("📜 Fetching redeem history");
      fetchRedeemHistory();
    } else {
      console.log("🛍️ Fetching rewards for redeem tab");
      fetchRewards();
    }
  }, [activeTab]);

  const handleRedeem = async (rewardId, points, earned) => {
    // alert(points + "__" + earned)
    if (points > earned) {
      toast.error("Need More Points To Redeem This Gift", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    setLoading(true);
    // alert(rewardId)
    const payload = {
      Gift_id: rewardId,
      User_id: userInfo?.User_id,
    };
    try {
      const response = await axios.post(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/redeemGift`,
        payload, // Send JSON directly
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json", // Ensure JSON content type
          },
        }
      );

      if (response.data.success) {
        toast.success("Gift redeemed successfully!", {
          position: toast.POSITION.TOP_CENTER,
          className: "kid-toast",
        });

        // Refresh the rewards list and earned points
        await fetchRewards();
        await fetchRewardsEarned();
      } else {
        toast.error("Failed to redeem gift. Please try again.", {
          position: toast.POSITION.TOP_CENTER,
          className: "kid-toast",
        });
      }
    } catch (error) {
      console.error("Error redeeming gift:", error);
      toast.error("Failed to redeem gift. Please try again.", {
        position: toast.POSITION.TOP_CENTER,
        className: "kid-toast",
      });
    } finally {
      setLoading(false);
    }
  };

  const onLogout = () => {
    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: "include",
      method: "POST",
    })
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
    setUserInfo(null);
    setUserRole("guest");
  };

  const username = userInfo?.username;

  return (
    <>
      {<StudentNav username={username} onLogout={onLogout} />}
      <div className="student-reward-page">
        <Header title="Rewards" />
        <div className="summary-card">
          <h1 className="page--title">Redeem Points</h1>
          <div className="summary-details">
            <div className="summary-item">
              <span className="summary-icon">💰</span>
              <span className="summary-label">Total Rewards Earned:</span>
              <span className="summary-value">{Rewards_Earned.earned}</span>
            </div>
            <div className="summary-item">
              <span className="summary-icon">🎉</span>
              <span className="summary-label">Rewards Redeemed:</span>
              <span className="summary-value">{Rewards_Earned.redeemed}</span>
            </div>
            <div className="summary-item">
              <span className="summary-icon"><RiCopperCoinFill color="#FFD700" size={30} /></span>
              <span className="summary-label">My Points:</span>
              <span className="summary-value">
                {parseInt(Rewards_Earned.earned) -
                  parseInt(Rewards_Earned.redeemed)}
              </span>
            </div>
          </div>
        </div>
        <div className="kid-redeem-container">
          <h1 className="page--title"> Fun Rewards Shop </h1>

          <div className="tabs-container">
            <button
              className={`tab-button ${activeTab === "redeem" ? "active" : ""}`}
              onClick={() => setActiveTab("redeem")}
            >
              🛍️ Redeem Gifts
            </button>
            <button
              className={`tab-button ${activeTab === "history" ? "active" : ""
                }`}
              onClick={() => setActiveTab("history")}
            >
              📜 Your Redeem History
            </button>
          </div>

          <div className="tab-content">
            {loading ? (
              <div className="loading-spinner">Loading rewards...</div>
            ) : activeTab === "redeem" ? (
              <div className="gifts-grid">
                {rewards.map((reward) => (
                  <div key={reward.Gift_id} className="gift-card">
                    {reward.giftpicture ? (
                      <img
                        src={
                          (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API) +
                          "/" +
                          reward.giftpicture
                        }
                        // alt={reward.giftname}
                        className="gift-image"
                      />
                    ) : (
                      <div className="gift-emoji">🎁</div>
                    )}
                    <h3>{reward.giftname}</h3>
                    <button
                      className="terms-button"
                      onClick={() => {
                        setSelectedTerms(reward.TermsConditions);
                        setShowTermsModal(true);
                      }}
                    >
                      View Terms & Conditions
                    </button>
                    <p className="points">{reward.pointscost} points</p>
                    <button
                      className={
                        parseInt(reward.pointscost) <= earnedPoints
                          ? "redeem-button"
                          : "redeem-button-disabled"
                      }
                      onClick={() =>
                        handleRedeem(
                          reward.Gift_id,
                          parseInt(reward.pointscost),
                          earnedPoints
                        )
                      }
                      disabled={loading || parseInt(reward.pointscost) > earnedPoints}
                      title={
                        parseInt(reward.pointscost) <= earnedPoints
                          ? "Redeem"
                          : "Not Enough Points"
                      }
                    >
                      {loading ? "Redeeming..." : "Redeem Now!"}
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div className="history-list">
                {redeemHistory.length > 0 ? (
                  redeemHistory.map((item) => (
                    <div key={item.id} className="history-item">
                      {item.giftpicture ? (
                        <img
                          src={
                            (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API) +
                            "/" +
                            item.giftpicture
                          }
                          alt={item.gift}
                          className="history-item-image"
                        />
                      ) : (
                        <div className="history-item-emoji">🎁</div>
                      )}
                      <div className="item-details">
                        <h3>{item.gift}</h3>
                        <p>Date: {item.date}</p>
                        <p
                          className={`status ${item.status
                            .toLowerCase()
                            .replace(" ", "-")}`}
                        >
                          Status: {item.status}
                        </p>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-history">
                    <p>No redeem history found</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Terms & Conditions Modal */}
      {showTermsModal && (
        <div className="terms-modal-overlay">
          <div className="terms-modal">
            <h3>Terms & Conditions</h3>
            <div className="terms-content">
              {selectedTerms?.split("\n").map((line, i) => (
                <p key={i} className="term-line">
                  {line.startsWith("-") ? "•" + line.substring(1) : line}
                </p>
              ))}
            </div>
            <button
              className="close-button"
              onClick={() => setShowTermsModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default StduentReward;
